import React, { useEffect, useState } from 'react';
import client from '../feathers';

export const useBarges = (query) => {
  const [state, setState] = useState([]);

  useEffect(() => {
    const fetchBarges = async (query) => {
      const result = await client.service('barges').find({ query });
      setState(result.data);
    };
    fetchBarges(query);
  }, []);

  return state;
};
